export type BarcodeFieldError = 'empty' | 'duplicate' | null;

export interface EditBarcodeRow {
  plateId: number;
  plateLabel: string;
  lotLabel?: string;
  barcode: string;
  initialBarcode: string;
  plateNumber: number;
}

export interface EditBarcodeRowValidation {
  fieldError: BarcodeFieldError;
  isCheckingSystem: boolean;
}

export const BARCODE_EMPTY_ERROR = 'Barcode cannot be empty.';
export const BARCODE_DUPLICATE_ERROR =
  'Barcode already exists. Please enter a unique barcode.';

export type EditBarcodeBulkModalHandlersRef = {
  getUpdates: () => { plateId: number; barcode: string }[];
};

export const BARCODE_MAX_LENGTH = 50;
export const SYSTEM_CHECK_DEBOUNCE_MS = 400;
export const TABLE_ID = 'editbarcodebulkmodalbody';

export const TABLE_COLUMNS = [
  { id: 'error', title: '', textAlign: 'center' as const },
  { id: 'plateId', title: 'Plate ID', textAlign: 'left' as const },
  { id: 'barcode', title: 'Barcode', textAlign: 'left' as const },
];
